import type { TransportOperationRequest } from "@/types_api/backend/transport/operations"

const MAX_RUN_TAGS = 20

export type UpdateRunTagsRequest = TransportOperationRequest<"updateRunTags">
type UpdateRunTags = NonNullable<UpdateRunTagsRequest["tags"]>

export function toUpdateRunTags(tags: string[]): UpdateRunTags {
  return tags.slice(0, MAX_RUN_TAGS) as UpdateRunTags
}
